import { useTranslation } from 'react-i18next';
import { AmountDisplay } from '@/components/common/AmountDisplay';
import { getUserExpenseShare, type ExpenseShareSource } from '@/lib/expenseShare';

interface ExpenseShareLabelProps {
  expense: ExpenseShareSource & { currency_code_src: string };
  userId: string | undefined;
}

/** "you lent X" / "You owe X" line shown under an expense's total amount. */
export function ExpenseShareLabel({ expense, userId }: ExpenseShareLabelProps) {
  const { t } = useTranslation();

  const share = getUserExpenseShare(expense, userId);
  if (!share) return null;

  const isLent = share.kind === 'lent';
  const colorClass = isLent ? 'text-emerald-600' : 'text-orange-600';

  return (
    <div className="flex items-center justify-end gap-1 mt-0.5">
      <span className={`text-[11px] ${colorClass}`}>
        {isLent ? t('web:common.youLent') : t('expenses:participant.youOwe')}
      </span>
      <AmountDisplay
        amountMinor={share.amountMinor}
        currency={expense.currency_code_src}
        className={`text-[11px] font-medium ${colorClass}`}
      />
    </div>
  );
}
